import { useState, useEffect, useCallback } from 'react';

export interface ParsingOptions {
  parseNickname: boolean;
  parseProductName: boolean;
}

const defaultOptions: ParsingOptions = {
  parseNickname: true,
  parseProductName: true,
};

const storageKey = 'parsingOptions';

// 훅 인스턴스 state는 localStorage와 라이브 동기화되지 않으므로(인스턴스별 useState),
// 이벤트 시점에 최신 옵션이 필요한 비-렌더 경로는 이 리더로 직접 읽는다.
// UI 훅(useParsingOptions) init과 동일 시맨틱스로 정렬 — defaults 머지가 UI와 다른 판정을 만들던 문제 제거.
export const readParsingOptions = (): ParsingOptions => {
  if (typeof window === 'undefined') return defaultOptions;
  try {
    const savedOptions = window.localStorage.getItem(storageKey);
    return savedOptions ? JSON.parse(savedOptions) : defaultOptions;
  } catch (error) {
    console.error("Error parsing parsingOptions from localStorage", error);
    return defaultOptions;
  }
};

export const useParsingOptions = () => {
  const [parsingOptions, setParsingOptions] = useState<ParsingOptions>(() => {
    if (typeof window === 'undefined') {
      return defaultOptions;
    }
    try {
      const savedOptions = window.localStorage.getItem(storageKey);
      return savedOptions ? JSON.parse(savedOptions) : defaultOptions;
    } catch (error) {
      console.error("Error parsing parsingOptions from localStorage", error);
      return defaultOptions;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(parsingOptions));
    } catch (error) {
      console.error("Error saving parsingOptions to localStorage", error);
    }
  }, [parsingOptions]);

  const setOptions = useCallback((newOptions: Partial<ParsingOptions>) => {
    setParsingOptions(prevOptions => ({ ...prevOptions, ...newOptions }));
  }, []);

  return { parsingOptions, setOptions };
};